import { useState } from "react";
import { SpeakerHigh, X } from "@phosphor-icons/react";
import { playNewMessageAlert } from "@/hooks/useChatAlerts";

const KEY = "gbs_chat_sound_enabled"; // "on" | "dismissed"

// One-time banner (admin & petugas). Tapping the button plays the notification voice
// "Ada pesan baru masuk di Room Chat GBS" inside the user gesture — this both tests the
// sound and unlocks audio/speech (required by iOS Safari). Preference persists on device.
export default function ChatSoundBanner() {
  const [state, setState] = useState(() => {
    try { return localStorage.getItem(KEY); } catch (e) { return "on"; }
  });
  if (state) return null;

  const activate = () => {
    playNewMessageAlert();
    try { localStorage.setItem(KEY, "on"); } catch (e) {}
    setState("on");
  };
  const dismiss = () => {
    try { localStorage.setItem(KEY, "dismissed"); } catch (e) {}
    setState("dismissed");
  };

  return (
    <div data-testid="chat-sound-banner" className="flex items-center gap-3 rounded-xl border border-purple-100 bg-[#F7F0FF] p-3">
      <SpeakerHigh size={20} weight="duotone" className="shrink-0 text-[#6A38C7]" />
      <p className="min-w-0 flex-1 text-xs text-slate-600">
        Aktifkan suara notifikasi agar tidak ketinggalan pesan baru di Room Chat GBS.
      </p>
      <button
        data-testid="chat-sound-enable"
        onClick={activate}
        className="shrink-0 rounded-full bg-[#6A38C7] px-3 py-1.5 text-xs font-bold text-white transition-transform active:scale-95"
      >
        Aktifkan suara notifikasi
      </button>
      <button data-testid="chat-sound-dismiss" onClick={dismiss} aria-label="Tutup" className="shrink-0 text-slate-400 hover:text-slate-600">
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
